import { useLocation, useNavigate } from "react-router";
import { BottomNavigation, IconChatFill, IconChatLine, IconHouseFill, IconHouseLine, IconPersonFill, IconPersonLine } from "@hamlak/ui";
import { t } from "@/i18n/ko";

type Tab = "home" | "chats" | "me";
const TAB_PATH: Record<Tab, string> = { home: "/home", chats: "/chats", me: "/me" };
type TabState = { fromHomeTab?: true } | null;

/**
 * /home·/chats·/me 에서만 노출. 비회원이 대화·마이페이지를 누르면 회원 가드가 로그인으로 보낸다.
 * 백스택은 [홈, 탭 하나]까지만 쌓는다: 홈 → 탭은 push, 탭 → 탭은 replace, 탭 → 홈은 홈에서 왔으면 뒤로.
 * 그래서 Android 뒤로가기는 탭 → 홈 → 종료.
 */
export function BottomTabs({ current }: { current: Tab }) {
  const navigate = useNavigate();
  const location = useLocation();
  const fromHome = (location.state as TabState)?.fromHomeTab === true;

  const go = (key: Tab) => {
    if (key === current) return;
    if (current === "home") return void navigate(TAB_PATH[key], { state: { fromHomeTab: true } });
    if (key === "home") return void (fromHome ? navigate(-1) : navigate("/home", { replace: true }));
    void navigate(TAB_PATH[key], { replace: true, state: location.state });
  };

  return (
    <BottomNavigation<Tab>
      className="bottom-nav"
      value={current}
      onChange={go}
      items={[
        { key: "home", label: t("nav.home"), icon: <IconHouseLine />, selectedIcon: <IconHouseFill /> },
        { key: "chats", label: t("nav.chats"), icon: <IconChatLine />, selectedIcon: <IconChatFill /> },
        { key: "me", label: t("nav.me"), icon: <IconPersonLine />, selectedIcon: <IconPersonFill /> },
      ]}
    />
  );
}
